const OrderingModel = function () {
    return {
        headers: [],
        chosen: {},
        places: 0,
        default: null,
        setHeaders: function (headers) {
            if (this._headersInitialized) return;
            this._headersInitialized = true;
            this.headers = [...headers];
            let hasActive = false;
            this.headers.forEach((header) => {
                header.value = 1;
                if (header.direction === "desc") {
                    header.value = -1;
                }
                if (header.active) {
                    this.handleSort(header.attr);
                    hasActive = true;
                }
                if (header.default) {
                    this.default = header;
                }
            });
            if (!this.default) {
                console.error("No default header found. Please set a default header.");
                this.default = this.headers[0];
            }
            if (!hasActive) {
                this.handleSort(this.default.attr);
            }
        },
        getParams: function () {
            let keys = Object.keys(this.chosen);
            if (keys.length === 0) return {};
            let selected = keys.map((key) => {
                return {place: this.chosen[key].place, value: key * this.chosen[key].value};
            });
            selected.sort((a, b) => a.place - b.place);
            return {o: selected.map((item) => item.value).join(",")};
        },
        handleSort: function (columnId) {
            let id = columnId + 1;
            let value, place;

            if (!(id in this.chosen)) {
                this.chosen = {};
                this.places = 0;
                this.headers.forEach((header) => {
                    header.active = false;
                });
            }

            if (id in this.chosen) {
                value = this.chosen[id].value * -1;
                place = this.chosen[id].place;
            } else {
                this.places++;
                place = this.places;
                value = 1;
            }
            this.chosen[id] = {value: value, place: place};
            this.headers[columnId].direction = this.chosen[id].value === 1 ? "asc" : "desc";
            this.headers[columnId].active = true;
            this.applyOrder();
        },
        removeSort: function (columnId) {
            let id = columnId + 1;
            this.headers[columnId].active = false;
            let place = this.chosen[id].place;
            delete this.chosen[columnId + 1];
            Object.keys(this.chosen).forEach((key) => {
                if (this.chosen[key].place > place) {
                    this.chosen[key].place--;
                }
            });
            this.places--;
            if (this.places === 0) {
                this.handleSort(this.default.attr);
            }
            this.applyOrder();
        },

        applyOrder: () => {},
    };
};
export default OrderingModel;
